import { Injectable, Signal, WritableSignal, inject, signal } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { LocalStorage } from '../../../services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private readonly localStorage = inject(LocalStorage);

  private readonly _mobileOpen: WritableSignal<boolean> = signal(false);
  private readonly _sidebarCollapsed: WritableSignal<boolean> = signal(false);

  public get mobileOpen(): Signal<boolean> {
    return this._mobileOpen;
  }

  public set mobileOpen(value: boolean) {
    this._mobileOpen.set(value);
  }

  public get sidebarCollapsed(): Signal<boolean> {
    return this._sidebarCollapsed;
  }

  public set sidebarCollapsed(value: boolean) {
    this.localStorage.setItem(environment.keys.sidebarCollapsed, value);
    this._sidebarCollapsed.set(value);
  }

  public toggle(): void {
    this._mobileOpen.update(v => !v);
  }

  public toggleSidebarCollapsed(): void {
    this.sidebarCollapsed = !this._sidebarCollapsed();
  }

  public initialize(): void {
    const collapsed = this.localStorage.getItem<boolean>(environment.keys.sidebarCollapsed);

    if (collapsed !== null) {
      this._sidebarCollapsed.set(collapsed);
    }
  }
}
